import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React, {useEffect, useRef, useState} from "react";
import {BuildingStatTypes} from "../../utils/constants";
import BuildingStatDetailModal from "../../pages/building/building-stat-detail-modal";
import FormatService from "../../services/format-service";
import MyHighchart from "../my-highchart";
import HelperService from "../../services/helper-service";

export default function BuildingStatWidgetContent({
                                                    stat,
                                                    buildingId=null,
                                                    second=null,
                                                    third=null,
                                                    fourth=null,
                                                    widgetClass=null,
                                                    containerClass=null,
                                                    ...props
}) {

  const statDetailModal = useRef();
  const dayjs = HelperService.getDayjs();

  const [statType, setStatType] = useState(null);
  const lineGraphWidgets = [
    BuildingStatTypes.profit.val.toString()
  ];
  const barGraphWidgets = [
    BuildingStatTypes.rent.val.toString()
  ];
  const specialWidgets = [
    BuildingStatTypes.capacity.val.toString()
  ];
  const oneRowWidgets = [
    BuildingStatTypes.buildingValue.val.toString()
  ];
  const simpleWidgets = [
    BuildingStatTypes.lentArea.val.toString(),
    BuildingStatTypes.parkingPlaces.val.toString(),
    BuildingStatTypes.repairFund.val.toString(),
  ];

  //this is used for default rendering - same as simple widgets
  const allDefinedWidgets = [...lineGraphWidgets, ...barGraphWidgets, ...oneRowWidgets, ...simpleWidgets, ...specialWidgets];


  useEffect(()=>{
    if (stat?.building_stat_type){
      setStatType(stat.building_stat_type);
    } else {
      setStatType(null);
    }
  }, [stat, second]);

  const openStatDetailModal = (statTypeId)=>{
    statDetailModal.current.openModal(buildingId, statTypeId)
  };

  const DetailLink = function(){
    return (<a className="btn btn-sm btn-light p-0 btn-circle d-inline-flex ms-1 shadow-none" onClick={(e)=>openStatDetailModal(stat.type_sync_id)}>
      <span className="mdi mdi-open-in-new"></span></a>)
  }

  const StatTrend = function (){
    return (
      <OverlayTrigger overlay={<Tooltip>{stat.trend_text}</Tooltip>}>
        <div className="d-inline-block bg-white rounded-1 p-1">
          <div className={`text-${stat.trend>0?'success':'danger'}`}><span className={`mdi mdi-arrow-${stat.trend>0?'up':'down'}`}></span> {FormatService.formatNumber(Math.abs(stat.trend))}%</div>
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <>
      {buildingId && <BuildingStatDetailModal ref={statDetailModal} />}

      {statType && barGraphWidgets.includes(stat.type_sync_id) && stat?.last && <div className={containerClass}><div className={widgetClass}>
        <div className="row">
          <div className="col-6">
            <h5>{statType.title}{buildingId && <DetailLink />}</h5>
            <h3>{FormatService.formatNumber(stat.last?.stat)} <span dangerouslySetInnerHTML={{ __html: statType.metric }}></span></h3>
            {stat.trend_text && <StatTrend />}
          </div>
          <div className="col-6">
            {stat.chart?.length>0 && <MyHighchart titleY={null} options={{
              series: [
                {
                  id: statType.val,
                  name: statType.title,
                  type: 'column',
                  groupPadding: 0,
                  color: "#737fed",
                  data: stat.chart.map((i)=> [dayjs(i.x, 'DD.MM.YYYY').valueOf(), i.value])
                },
              ],
              legend: {enabled: false},
              xAxis: {visible: false},
              yAxis: {visible: false},
              chart: {
                spacing: [0,0,0,0],
                height: 140
              },
            }} />}
          </div>
        </div>
      </div></div>}

      {statType && lineGraphWidgets.includes(stat.type_sync_id) && stat?.last && <div className={containerClass}><div className={widgetClass}>
        <div className="row">
          <div className="col-6">
            <h5>{statType.title}{buildingId && <DetailLink />}</h5>
            <h3>{FormatService.formatNumber(stat.last?.stat)} <span dangerouslySetInnerHTML={{ __html: statType.metric }}></span></h3>
            {stat.trend_text && <StatTrend />}
          </div>
          <div className="col-6">
            {stat.chart?.length>0 && <MyHighchart titleY={null} options={{
              series: [
                {
                  id: statType.val,
                  name: statType.title,
                  type: 'line',
                  color: "#737fed",
                  data: stat.chart.map((i)=> [dayjs(i.x, 'DD.MM.YYYY').valueOf(), i.value])
                },
              ],
              legend: {enabled: false},
              xAxis: {visible: false},
              yAxis: {visible: false},
              chart: {
                height: 140
              },
            }} />}
          </div>
        </div>
      </div></div>}

      {statType && BuildingStatTypes.capacity.val.toString() === stat.type_sync_id && stat?.last && second?.last && third?.last && <div className={containerClass}><div className={widgetClass}>
        <div className="d-flex align-items-center justify-content-between">
          <h5>{statType.title}{buildingId && <DetailLink />}</h5>
          <h5>{stat?.last?.stat + second?.last?.stat + third?.last?.stat}%</h5>
        </div>
        <div className="progress" style={{height: '1.5rem'}}>
          {stat?.last && <OverlayTrigger overlay={<Tooltip>{BuildingStatTypes.capacity.description}: {FormatService.formatNumber(stat.last.stat)+"%"}</Tooltip>}>
            <div className="progress-bar bg-indigo py-2" role="progressbar" style={{width: `${stat?.last?.stat}%`}} aria-valuenow={stat?.last?.stat} aria-valuemin="0" aria-valuemax="100">{stat?.last?.stat}%</div>
          </OverlayTrigger>}
          {second?.last && <OverlayTrigger overlay={<Tooltip>{BuildingStatTypes.capacityAccepted.description}: {FormatService.formatNumber(second.last.stat)+"%"}</Tooltip>}>
            <div className="progress-bar bg-success py-2" role="progressbar" style={{width: `${second?.last?.stat}%`}} aria-valuenow={second?.last?.stat} aria-valuemin="0" aria-valuemax="100">{second?.last?.stat}%</div>
          </OverlayTrigger>}
          {third?.last && <OverlayTrigger overlay={<Tooltip>{BuildingStatTypes.capacityReserved.description}: {FormatService.formatNumber(third.last.stat)+"%"}</Tooltip>}>
            <div className="progress-bar bg-danger py-2" role="progressbar" style={{width: `${third?.last?.stat}%`}} aria-valuenow={third?.last?.stat} aria-valuemin="0" aria-valuemax="100">{third?.last?.stat}%</div>
          </OverlayTrigger>}
          {fourth?.last && <OverlayTrigger overlay={<Tooltip>{BuildingStatTypes.capacityFree.description}: {FormatService.formatNumber(fourth.last.stat)+"%"}</Tooltip>}>
            <div className="progress-bar bg-light py-2 text-dark" role="progressbar" style={{width: `${fourth?.last?.stat}%`}} aria-valuenow={fourth?.last?.stat} aria-valuemin="0" aria-valuemax="100">{fourth?.last?.stat}%</div>
          </OverlayTrigger>}
        </div>
      </div></div>}

      {statType && oneRowWidgets.includes(stat.type_sync_id) && stat?.last && <div className={containerClass}><div className={widgetClass}>
        <div className="row">
          <div className="col-12 d-flex justify-content-between flex-wrap align-items-center">
            <h5>{statType.title}{buildingId && <DetailLink />}</h5>
            <h3>{FormatService.formatNumber(stat.last?.stat)} <span dangerouslySetInnerHTML={{ __html: statType.metric }}></span></h3>
            {stat.trend_text && <StatTrend />}
          </div>
        </div>
      </div></div>}

      {statType && (simpleWidgets.includes(stat.type_sync_id) || !allDefinedWidgets.includes(stat.type_sync_id)) && stat?.last && <div className={containerClass}><div className={widgetClass}>
        <div className="row">
          <div className="col-12">
            <h5>{statType.title}{buildingId && <DetailLink />}</h5>
            <h3>{FormatService.formatNumber(stat.last?.stat)} <span dangerouslySetInnerHTML={{ __html: statType.metric }}></span></h3>
            {stat.trend_text && <StatTrend />}
          </div>
        </div>
      </div></div>}

    </>
  );
}
